import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { map, Observable } from 'rxjs';
import { SearchResponse } from './search.types';

@Injectable({ providedIn: 'root' })
export class SearchService {
    private readonly apiLink = environment.apiLink;
    private readonly _httpClient = inject(HttpClient);

    /**
     * Global search across agents, data sources, tables, hyper forms, dashboards, reports,
     * trackers and tasks - scoped server-side to the current user/member/staff.
     */
    search(query: string, limit: number = 30): Observable<SearchResponse> {
        return this._httpClient
            .get<{ data: SearchResponse }>(`${this.apiLink}search?q=${encodeURIComponent(query)}&limit=${limit}`)
            .pipe(map(res => res.data));
    }
}
